import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=550abf78"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=550abf78&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('550abf78')) {
      api.createRecord('550abf78', component.options)
    } else {
      api.reload('550abf78', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=550abf78", function () {
      api.rerender('550abf78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/package/components/DataForm.vue"
export default component.exports